import { createTranslations } from '@momentum/i18n';
import { knowledgeEnTranslations } from './knowledge.en';

export const knowledgeHeTranslations = createTranslations(
  knowledgeEnTranslations,
  {
    // Page
    pageTitle: 'ידע ארגוני',
    pageSubtitle: 'למד מניסיון העבר כדי לבנות עתיד טוב יותר',

    // Actions
    addSignal: 'צור סוכן',
    importFromFile: 'ייבוא מקובץ',
    addYourFirstSignal: 'הוסף את הסוכן הראשון שלך',
    edit: 'ערוך',
    editSignal: 'ערוך סוכן',
    deleteSignal: 'מחק',
    retry: 'נסה שוב',

    // Delete confirmation
    deleteSignalTitle: 'מחיקת סוכן',
    deleteSignalDescription: (text: string) =>
      `האם אתה בטוח שברצונך למחוק את הסוכן הזה? פעולה זו לא ניתנת לביטול.\n\n"${text.substring(
        0,
        100
      )}${text.length > 100 ? '...' : ''}"`,
    deleteSignalCancel: 'ביטול',
    deleteSignalConfirm: 'מחק',
    deleteSignalDeleting: 'מוחק...',
    deleteSignalSuccess: 'הסוכן נמחק בהצלחה',
    deleteSignalError: 'נכשל במחיקת הסוכן',

    // Create signal
    createSignalTitle: 'יצירת סוכן',
    createSignalDescription: 'הוסף סוכן חדש לידע הארגוני שלך',
    createSignalPlaceholder: 'מה למדת? תאר את הסוכן ולמה הוא חשוב...',
    createSignalCancel: 'ביטול',
    createSignalCreate: 'צור סוכן',
    createSignalCreating: 'יוצר...',
    createSignalSuccess: 'הסוכן נוצר בהצלחה',
    createSignalError: 'נכשל ביצירת הסוכן',

    // Create signal form — breadcrumb
    createSignalBreadcrumb: 'סוכנים',
    createSignalBreadcrumbNew: 'סוכן חדש',

    // Create signal form — sections
    propertiesSection: 'מאפיינים',
    visibilitySection: 'נראות',
    // Create signal form — severity
    severityLabel: 'חומרה',
    severityTooltip: 'כמה משמעותי הסוכן הזה?',
    severityLow: 'נמוך',
    severityMedium: 'בינוני',
    severityHigh: 'גבוה',
    severityCritical: 'קריטי',

    // Create signal form — relevant parties
    relevantPartiesLabel: 'גורמים רלוונטיים',
    relevantPartiesTooltip: 'אנשים או צוותים שהסוכן רלוונטי עבורם',
    relevantPartiesPlaceholder: 'הוסף',
    detailNoRelevantParties: 'אין',

    // Create signal form — marketplace
    marketplaceLabel: 'שוק',
    marketplaceTooltip: 'שלוט מי יכול לראות את זה בשוק',
    marketplacePublic: 'ציבורי',
    marketplacePrivate: 'פרטי',

    // Create signal form — visible to
    visibleToLabel: 'גלוי ל',
    visibleToTooltip: 'בחר מי יכול לצפות בסוכן הפרטי הזה',
    visibleToPlaceholder: 'הוסף',
    lockedViewerTooltip: 'לא ניתן להסיר צופה זה',

    // Create signal form — anonymous
    anonymousLabel: 'אנונימי',
    anonymousTooltip: 'הסתר את שמך כמחבר הסוכן',
    showMyName: 'הצג את שמי',
    anonymous: 'אנונימי',

    // Create signal form — applicability scope
    applicabilitySection: 'יישום',
    applicabilityBadge: 'מנהל',
    scopeLabel: 'החל על',
    scopeTooltip: 'בחר למי הסוכן הזה חל',
    scopeSelf: 'רק אני',
    scopeDirectReports: 'אני + כפיפים ישירים',
    scopeFullHierarchy: 'אני + כל הכפיפים שלי',

    // Create signal form — picker labels
    pickerTeamsGroup: 'צוותים',
    pickerPeopleGroup: 'אנשים',
    pickerSearchPlaceholder: 'חיפוש...',
    pickerNoResults: 'לא נמצאו תוצאות',

    // Edit signal
    editSignalTitle: 'עריכת סוכן',
    editSignalDescription: 'עדכן את טקסט הסוכן למטה',
    editSignalPlaceholder: 'הזן טקסט סוכן...',
    editSignalCancel: 'ביטול',
    editSignalSave: 'שמור',
    editSignalSaving: 'שומר...',
    editSignalSuccess: 'הסוכן עודכן בהצלחה',
    editSignalError: 'נכשל בעדכון הסוכן',

    // Status
    active: 'פעיל',
    inactive: 'לא פעיל',
    activate: 'הפעל',
    deactivate: 'כבה',
    activateSignalError: 'נכשל בהפעלת הסוכן',
    deactivateSignalError: 'נכשל בכיבוי הסוכן',

    // Activate scope dialog
    activateDialogTitle: 'הפעלת סוכן',
    activateDialogDescription: 'בחר עבור מי להפעיל את הסוכן',
    scopeCountYou: 'אתה',
    scopeJustMe: 'רק אני',
    scopeJustMeDesc: 'הפעל רק עבורך',
    scopeDirectReportsActivate: 'כפיפים ישירים',
    scopeDirectReportsActivateDesc: 'הפעל עבורך ועבור הכפיפים הישירים שלך',
    scopeFullHierarchyActivate: 'כל ההיררכיה',
    scopeFullHierarchyActivateDesc: 'הפעל עבורך ועבור כל הכפיפים שלך',
    activateDialogConfirm: 'הפעל',
    activateDialogActivating: 'מפעיל...',

    // Deactivate confirmation dialog
    deactivateDialogTitle: 'כיבוי סוכן',
    deactivateDialogAppliedText: (scope: string, count: number) =>
      `סוכן זה מוחל על ${scope} שלך. כיבוי יסיר אותו מ-${count} ${
        count === 1 ? 'אדם' : 'אנשים'
      }.`,
    deactivateDialogConfirm: 'כבה',
    deactivateDialogDeactivating: 'מכבה...',
    deactivateDialogCancel: 'ביטול',

    // Applied treatment
    appliedByTooltip: (name: string) => `הוחל על ידי ${name}`,
    appliedToScope: (scope: string, count: number) =>
      `הוחל על ${scope} (${count} ${count === 1 ? 'אדם' : 'אנשים'})`,
    appliedToDirectReports: 'כפיפים ישירים',
    appliedToFullHierarchy: 'כל ההיררכיה',

    // Detail modal — applicability scope section
    detailScopeApply: 'החל',
    detailScopeApplyPrompt:
      'סוכן זה פעיל רק עבורך. רוצה להחיל אותו על הצוות שלך?',
    detailScopeApplyToTeam: 'החל סוכן זה על הצוות שלך:',
    detailScopeAppliedBy: (name: string) => `הוחל ע"י ${name}`,
    detailScopeAppliedByYouTo: 'הוחל על ידך על',
    detailScopeMembers: (count: number) =>
      `${count} ${count === 1 ? 'חבר' : 'חברים'}`,
    detailScopeOnlyMe: 'רק אני',
    detailScopeApplying: 'מחיל...',
    detailScopeChanging: 'משנה...',
    detailScopeApplyError: 'החלת הסוכן נכשלה',
    detailScopeUnapplyError: 'הסרת החלת הסוכן נכשלה',

    // Filters
    searchPlaceholder: 'חפש סוכנים...',
    allSources: 'כל המקורות',
    sortBy: 'מיין לפי',
    newestFirst: 'החדשים ביותר',
    oldestFirst: 'הישנים ביותר',
    mostRelevant: 'הרלוונטיים ביותר',
    filterByInteractionId: 'סנן לפי מזהה אינטראקציה',
    interactionIdPlaceholder: 'הזן מזהה אינטראקציה (אופציונלי)',

    // Sources
    ilearn: 'ILearn',
    ineedu: 'INeedU',
    manual: 'ידני',

    // Origin badges
    originDebrief: 'I Learn',
    originFeedback: 'I Need U',
    originManual: 'ידני',
    originExternal: 'מקור חיצוני',
    originExternalWord: 'מסמך Word',

    // Origin additional info
    fromInteraction: 'מאינטראקציה:',
    fromFile: 'מקובץ:',
    viewDebrief: 'הצג אינטראקציה',
    viewInteraction: 'הצג אינטראקציה',

    // States
    noSignalsFound: 'לא נמצאו סוכנים',
    noSignalsFoundDescription: 'נסה לשנות את החיפוש או הסינון',
    noSignalsYet: 'אין סוכנים עדיין',
    noSignalsYetDescription:
      'התחל לבנות את הידע הארגוני שלך על ידי הוספת הסוכן הראשון או יצירת אינטראקציות משוב',
    loadingSignals: 'טוען סוכנים...',
    aiAnalyzingDocuments: 'מנתח את המסמכים שלך',
    aiExtractingSignals: 'מחלץ סוכנים מהקבצים שהועלו',
    errorLoadingSignals: 'שגיאה בטעינת סוכנים',
    unexpectedError: 'אירעה שגיאה בלתי צפויה',

    // Signal details
    signalDetails: 'פרטי סוכן',
    viewAndManageSignal: 'הצג וניהל סוכן ארגוני זה',
    signal: 'סוכן',
    source: 'מקור',
    from: 'מ',
    created: 'נוצר',
    lastUpdated: 'עודכן לאחרונה',
    visibility: 'נראות',
    shared: 'משותף',
    sharedWithCompany: 'משותף עם החברה',
    private: 'פרטי',
    tags: 'תגיות',

    // Issue status labels
    statusTodo: 'לביצוע',
    statusInProgress: 'בטיפול',
    statusDone: 'הושלם',

    // Issue type labels
    issueTypeGoal: 'יעד',
    issueTypeTask: 'משימה',

    // Signal detail modal
    detailBreadcrumb: 'סוכנים',
    detailBreadcrumbCurrent: 'פרטי סוכן',
    detailInstalled: (count: number) =>
      count === 1 ? 'אחד התקינו' : `${count} התקינו`,
    detailViewSource: 'צפה במקור',
    detailLinkedIssues: 'המשימות המקושרות שלך',
    detailNoLinkedIssues: 'אין משימות מקושרות',
    detailActivity: 'פעילות',
    detailCreatedSignal: 'יצר את הסוכן',
    detailUpdatedSignal: 'עדכן את הסוכן',
    detailRemove: 'הסר',
    detailDeleteSignal: 'מחק סוכן',
    detailAuthor: 'מחבר',
    detailUnknownTeam: 'צוות לא ידוע',

    // Related issues
    relatedIssues: (count: number) =>
      count === 1 ? 'נושא קשור אחד' : `${count} נושאים קשורים`,

    // Count
    signalsFound: (count: number) => `נמצאו ${count} סוכנים`,
    signalCount: (count: number) =>
      count === 1 ? 'סוכן אחד' : `${count} סוכנים`,
    viewingFilteredSignals: (count: number) =>
      count === 1 ? 'מציג סוכן אחד מסונן' : `מציג ${count} סוכנים מסוננים`,
    viewAllSignals: 'הצג את כל הסוכנים',
    noAccessibleSignalsForIds: 'לא נמצאו סוכנים נגישים עבור המזהים שסופקו.',

    // Import from document (AI suggestions)
    importFromWord: 'ייבוא ממסמך',
    importingFile: 'מייבא מסמך...',
    importingDocument: 'מנתח מסמך ומחלץ סוכנים...',
    importFileInvalidType: 'ניתן להעלות רק קובצי Word (.docx/.doc)',
    importFileLimitExceeded: (max: number) =>
      `ניתן להעלות עד ${max} קבצים בכל פעם.`,
    importFileError: 'אירעה שגיאה בעיבוד המסמך שהועלה',
    importSuggestionsTitle: 'הצעות סוכנים מ-AI',
    importSuggestionsDescription:
      'סקור את ההצעות שנוצרו בעזרת AI מתוך המסמך ובחר אילו מהן להוסיף כסוכנים.',
    extractedTextPreview: 'תצוגה מקדימה של הטקסט שהופק',
    noSuggestionsFound: 'לא נמצאו הצעות AI למסמך זה',
    selectAll: 'בחר הכל',
    deselectAll: 'בטל בחירה של הכל',
    creatingSignals: 'יוצר סוכנים...',
    createSelected: 'צור סוכנים',
    fileNameLabel: 'שם הקובץ',
    importSuccess: (count: number) =>
      count === 1 ? 'נוצר סוכן אחד מהמסמך' : `נוצרו ${count} סוכנים מהמסמך`,

    // Visibility options (legacy — used by upload-signal selector)
    visibilityLabel: 'נראות הסוכן',
    visibilityDescription: 'בחר מי יכול לראות סוכנים אלו',
    visibilityPrivate: 'פרטי',
    visibilityPublic: 'ציבורי',
    visibilityPrivateDescription: 'רק אתה יכול לראות',
    visibilityPublicDescription: 'כל עובדי החברה יכולים לראות',

    // Update feedback
    updateSignalError: 'עדכון הסוכן נכשל',

    // Import modal
    importModal: {
      title: 'ייבוא מ-Word לאינטרה',
      description: 'העלה מסמכי Word כדי לחלץ סוכנים למאגר הידע שלך',
      reviewDescription: 'סקור ובחר את הסוכנים שחולצו מהמסמכים שלך',
      browse: 'בחר קבצים',
      orDragAndDrop: 'או גרור והנח כאן',
      fileTypes: 'רק קבצי .doc ו-.docx נתמכים',
      next: 'הבא',
      back: 'חזור',
      uploading: 'מעלה קבצים...',
      uploadSuccess: 'הקבצים הועלו בהצלחה',
      done: 'סיום',
      duplicateFile: 'הקובץ "{{fileName}}" כבר נבחר',
      duplicateFiles: '{{count}} קבצים כבר נבחרו',
      extractingSignals: 'מחלץ סוכנים מהמסמכים שלך...',
      files: 'קבצים',
      selectedCount: '{{count}} נבחרו',
      save: 'שמור',
      cancel: 'ביטול',
      editSignal: 'ערוך סוכן',
      createSignals_one: 'צור {{count}} סוכן',
      createSignals_other: 'צור {{count}} סוכנים',
      successSingle: 'סוכן אחד נוצר מהמסמך',
      successMultiple: '{{count}} סוכנים נוצרו מהמסמכים',
      uploadedFiles: 'קבצים שהועלו',
      noFilesYet:
        'עדיין לא הועלו קבצים. השתמש באזור הגרירה למעלה כדי להוסיף מסמכי Word.',
    },

    // Filter bar
    filterOwner: 'בעלים',
    filterSeverity: 'חומרה',
    filterStatus: 'סטטוס',
    filterCategory: 'קטגוריה',
    sortNewest: 'החדשים ביותר',
    sortSeverity: 'חומרה',
    clearAll: 'נקה הכל',

    // Category
    categoryCommitment: 'התחייבות',
    categoryPlaybook: 'פלייבוק',
    categoryCommitmentTooltip:
      'התחייבות ספציפית בין שני צדדים — לקוח, צוות או אדם — שעלולה לא להתקיים',
    categoryPlaybookTooltip:
      'כלל, נורמה או best practice — ארגוני, צוותי או לפי תפקיד — שעלול לא להישמר',

    // Informed by
    informedByLabel: 'בהשפעת',

    // Nudge
    nudgeSuggested: 'מוצע',
    nudgeSkip: 'דלג',

    // Upload CTA
    clickToUpload: 'העלה מסמך',

    // Marketplace
    marketplace: {
      title: 'שוק הסוכנים',
      searchPlaceholder: 'חפש סוכנים...',
      signalCount: (count: number) =>
        count === 1 ? 'סוכן אחד' : `${count} סוכנים`,
      browse: 'עיון',
      myImports: 'הסוכנים שלי',
      import: 'ייבא',
      imported: 'מיובא',
      remove: 'הסר',
      users: (count: number) =>
        count === 1 ? 'משתמש אחד' : `${count} משתמשים`,
      topRated: 'מובילים',
      anonymous: 'אנונימי',
      browseMarketplace: 'עיון בשוק',
      noSignalsFound: 'לא נמצאו סוכנים',
      noImports: 'עדיין לא ייבאת אף סוכן',
      noImportsDescription: 'עיין בשוק כדי למצוא סוכנים לייבא',
      importSuccess: 'הסוכן יובא בהצלחה',
      importError: 'ייבוא הסוכן נכשל',
      removeSuccess: 'הסוכן הוסר בהצלחה',
      removeError: 'הסרת הסוכן נכשלה',
    },

    // Integration sources
    integrations: {
      title: 'בחר מקור',
      subtitle: 'בחר אינטגרציה כדי לחלץ סוכנים מהמסמך שלך',
      importFrom: 'ייבוא ממקור',
      comingSoon: 'בקרוב',
      comingSoonMessage: (source: string) =>
        `אינטגרציה עם ${source} בקרוב! הישארו מעודכנים.`,
      moreComingSoon: 'עוד אינטגרציות בקרוב',
      word: {
        name: 'מסמך Word',
        description: 'ייבוא סוכנים מקבצי .docx או .doc',
      },
      googleDrive: {
        name: 'Google Drive',
        description: 'חיבור ל-Google Docs וייבוא תוכן',
      },
      confluence: {
        name: 'Confluence',
        description: 'ייבוא דפים מסביבת ה-Confluence שלך',
      },
      notion: {
        name: 'Notion',
        description: 'סנכרון ידע מדפי ה-Notion שלך',
      },
    },

    // Signal review dialog
    signalReview: {
      title: 'סקירת סוכנים שחולצו',
      defaultsDescription: 'הגדר ברירות מחדל לכל {{count}} הסוכנים',
      defaultsBanner:
        'ברירות מחדל אלו חלות על כל הסוכנים. ניתן לשנות לכל סוכן בשלב הבא.',
      cancel: 'ביטול',
      acceptAllDefaults: 'קבל הכל עם ברירות מחדל',
      reviewIndividually: 'סקירה בודדת',
      reviewSignals: 'סקירת סוכנים',
      editSignal: 'עריכת סוכן',
      signalLabel: 'סוכן',
      stepCounter: '{{current}} מתוך {{total}}',
      back: 'חזרה',
      skipSignal: 'בטל סוכן',
      acceptRemaining: 'קבל נותרים ({{count}})',
      next: 'הבא',
      finish: 'סיום',
      saveAndBack: 'שמור וחזור לסיכום',
      createSignals: 'יצירת סוכנים',
      summaryDescription: 'סקור את הסוכנים לפני יצירתם.',
      edited: 'נערך',
      selectedCount: '{{included}} מתוך {{total}} סוכנים נבחרו',
      backToDefaults: 'חזרה לברירות מחדל',
      restore: 'שחזור',
      anonymous: 'אנונימי',
      notAnonymous: 'לא אנונימי',
    },
  }
);
